import { CancellablePromise, get, post } from "@/api";
import type { Order, ProductIdentifiers } from "@/types";

interface FormDataRequest {
  product: ProductIdentifiers;
  cancelUrl: string;
  continueUrl: string;
}

export function createFormData(data: FormDataRequest): CancellablePromise<{
  url: string;
  parameters: {
    [key: string]: string | number;
  };
}> {
  return post("/v1/payment/form-data", data);
}

export function getOrder(orderId: number): CancellablePromise<Order> {
  return get("/v1/payment/order", { orderId });
}
